import { appApi } from './app_api';

export const customerPointCategoriesApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getDivisions: builder.query({
      query: (customerId) => `customers/${customerId}/point_categories/divisions`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, pointCategoryId) => [{ type: 'Divisions', id: pointCategoryId }],
    }),
    addDivision: builder.mutation({
      query: ({ customerId, division }) => ({
        url: `/customers/${customerId}/point_categories/divisions`,
        method: 'POST',
        body: division,
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Divisions', id: customerId }],
    }),
    editDivision: builder.mutation({
      query: ({ divisionId, customerId, division }) => ({
        url: `/customers/${customerId}/point_categories/divisions/${divisionId}`,
        method: 'PUT',
        body: division,
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Divisions', id: customerId }],
    }),
    editPointCalculation: builder.mutation({
      query: ({ customerId, eventTypeId, newRules }) => ({
        url: `/customers/${customerId}/event_types/${eventTypeId}/point_calculation_rules/${newRules.id}`,
        method: 'PUT',
        body: { point_calculation_rule: newRules },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'EventTypes', id: customerId }],
    }),
    editAverageCalculation: builder.mutation({
      query: ({ customerId, eventTypeId, newRules }) => ({
        url: `/customers/${customerId}/event_types/${eventTypeId}/average_calculation_rules/${newRules.id}`,
        method: 'PUT',
        body: { average_calculation_rule: newRules },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'EventTypes', id: customerId }],
    }),
  }),
});

export const {
  useGetDivisionsQuery,
  useAddDivisionMutation,
  useEditDivisionMutation,
  useEditPointCalculationMutation,
  useEditAverageCalculationMutation,
} = customerPointCategoriesApi;
